import { chakra, ChakraProps, Flex, Input, Text, useNumberInput } from "@chakra-ui/react";
import { langStore, translate } from "@noli/business";
import { observer } from "mobx-react-lite";

import { Editor_Words } from "@/utils/lang/editor";
import { statusStore, updateTxt2imgCustomSize } from "@/stores/status";
import { LabelText } from "../../styleComponents/Texts";
import { WithClassName } from "@/types/base";
import React from "react";
import { AI_MAX_WH } from "@/utils/constants";

const Label = chakra(Text, {
  baseStyle: {
    color: "text.secondary",
    fontSize: "sm",
    mr: "4px",
  },
});

const inputStyle: ChakraProps = {
  w: "71px",
  h: "30px",
  color: "text.secondary",
  rounded: "4px",
  textAlign: "center",
  borderColor: "text.secondary",
  outline: "none",
  fontSize: "14px",
  _focus: { border: "brand.primary" },
};
const ISizeInput: React.FC<
  WithClassName<{
    defaultW?: number;
    defaultH?: number;
    setW?: (w: number) => void;
    setH?: (h: number) => void;
    wMin?: number;
    wMax?: number;
    hMax?: number;
    hMin?: number;
  }>
> = (props) => {
  const lang = langStore.tgt;
  const { txt2imgCustomSize } = statusStore;
  const {
    className,
    defaultW = txt2imgCustomSize.w,
    defaultH = txt2imgCustomSize.h,
    setH = (h: number) => updateTxt2imgCustomSize("h", isNaN(h) ? 0 : h),
    setW = (w: number) => updateTxt2imgCustomSize("w", isNaN(w) ? 0 : w),
    wMin = 1,
    hMin = 1,
    hMax = AI_MAX_WH,
    wMax = AI_MAX_WH,
  } = props;

  const { getInputProps: getInputWProps } = useNumberInput({
    step: 1,
    precision: 0,
    min: wMin,
    max: wMax,
    defaultValue: defaultW,
    onChange(valueAsString, valueAsNumber) {
      setW(valueAsNumber);
    },
  });

  const inputW = getInputWProps();

  const { getInputProps: getInputHProps } = useNumberInput({
    step: 1,
    precision: 0,
    min: hMin,
    max: hMax,
    defaultValue: defaultH,
    onChange(valueAsString, valueAsNumber) {
      setH(valueAsNumber);
    },
  });

  const inputH = getInputHProps();

  return (
    <Flex className={className} w="100%" alignItems="center">
      <LabelText mr="16px">{translate(Editor_Words["txt2img-sd-size-title"], lang)}：</LabelText>
      <Label>W：</Label>
      <Input {...inputStyle} {...inputW} focusBorderColor="brand.primary" mr="24px" />
      <Label>H：</Label>
      <Input {...inputStyle} {...inputH} focusBorderColor="brand.primary" />
    </Flex>
  );
};

export const SizeInput = chakra(observer(ISizeInput));
